import React, { useEffect } from 'react';

// Extend existing gtag type
declare global {
  interface Window {
    dataLayer?: any[];
  }
}

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    // Check if user has accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      const consent = JSON.parse(cookieConsent);
      if (consent.analytics || consent.marketing) {
        // Load Google Tag Manager
        const script = document.createElement('script');
        script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17412433587';
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
          window.dataLayer!.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', 'AW-17412433587');
        
        // Set consent mode using event command
        window.gtag('event', 'consent_update', {
          'ad_storage': consent.marketing ? 'granted' : 'denied',
          'analytics_storage': consent.analytics ? 'granted' : 'denied'
        });
      }
    } else {
      // Default consent mode (DSGVO compliant - everything denied by default)
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer!.push(arguments);
      };
      window.gtag('event', 'consent_default', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500
      });
    }
  }, []);

  return null;
};

export default GoogleAnalytics;

// Conversion tracking helper
export const trackLeadConversion = () => {
  if (typeof window.gtag !== 'undefined') {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      const consent = JSON.parse(cookieConsent);
      if (consent.marketing) {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17412433587/YPgOCMODmfsaELPN8u5A',
          'value': 1.0,
          'currency': 'EUR'
        });
      }
    }
  }
};